import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent extends DialogBase implements OnInit {

  title: any;
  message: any;
  templateId: any;

  inputCells: any;
  tsvJson: any;
  tsvHeaders: any;
  pager: any = {};
  pagedItems: any[];

  ngOnInit(): void {
    this.onClose = new Subject();
    this.fileService.excelUploader(this.templateId, false);
    this.fileService.onAfterAddingFile$.subscribe(res => {
      if (res) {
        this.clearInputCells();
      }
    });
  }

  confirm() {
    this.fileService.uploader.uploadAll();
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  downloadTemplate() {
    this.fileService.getExcelTemplate(this.templateId);
  }

  generate() {
    this.tsvJson = this.tsvToJson(this.inputCells);
    if (this.tsvJson.length) {
      this.tsvHeaders = Object.keys(this.tsvJson[0]);
    }
    this.setPage(1);
  }

  fileToJson(data, select, delimiter) {
    const ESCAPES = ['\'', '"'];
    const lines = data.split(/\r\n|\n/);
    let headers = null;
    let lineItems = [];
    let escaped = null;
    return lines.reduce((ret, line) => {
      if (!line || !line.trim()) {
        return ret;
      }

      const tokens = line.split(delimiter);
      tokens.forEach(token => {
        // check escaped or not
        if (escaped) {
          if (token) {
            if (token.charAt(token.length - 1) === escaped.charAt(0)) {
              // token closing
              escaped += token;
              lineItems.push(escaped.substr(1, escaped.length - 2));
              escaped = null;
            } else {
              escaped += token;
            }
          } else {
            escaped += delimiter;
          }
        } else if (token) {
          // check if escape
          if (ESCAPES.includes(token.charAt(0))) {
            escaped = token;
          } else {
            lineItems.push(token);
          }
        } else {
          lineItems.push('');
        }
      });

      if (escaped) {
        escaped += '\n';
      } else {
        if (!headers) {
          headers = lineItems;
        } else {
          const items = {};
          lineItems.forEach((value, idx) => {
            const key = headers[idx];
            if (!key) {
              return;
            }
            items[key] = value;
          });
          ret.push(items);
        }

        lineItems = [];
      }
      return ret;
    }, []);
  }

  tsvToJson(tsvInputVal) {
    return this.fileToJson(tsvInputVal, null, '\t');
  }

  setPage(page: number) {
    this.pager = this.getPager(this.tsvJson.length, page);
    this.pagedItems = this.tsvJson.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    const totalPages = Math.ceil(totalItems / pageSize);

    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
      i => startPage + i
    );

    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

  onKeyInputCells(event: any) {
    if (!event.target.value) {
      this.clearInputCells();
    } else {
      this.generate();
    }
  }

  clearInputCells() {
    this.pagedItems = null;
    this.tsvHeaders = null;
    this.pager = null;
    this.inputCells = null;
    this.tsvJson = null;
  }

  remove() {
    this.fileService.uploader.clearQueue();
  }

  uploadInputCells() {
    const data = {
      tsv: this.inputCells
    };

    this.spinnerService.start();
    this.apiService.master.tsvCellsUpload(data, this.templateId, null, false)
      .pipe(finalize(() => {
        this.spinnerService.stop();
        this.close();
      }))
      .subscribe(res => {
        this.clearInputCells();
        if (res.status === 'queued') {
          Swal.fire({
            title: 'Update Tracking Status',
            html: 'The result of the data import<br>will be sent to your email in a few minutes.<br>Please check your email and refresh the page again.',
            icon: 'success',
            allowOutsideClick: true,
          });
        }
      }, error => {
        Swal.fire({
          title: 'Update Tracking Status',
          text: error.error.message,
          icon: 'error',
          allowOutsideClick: true,
        });
      });
  }
}
